import request from '@/utils/request'

const url = '/home/inquiry_list/'
const api = {
  query (data) {
    return request({
      url: url + 'query',
      method: 'post',
      data
    })
  },
  delete (data) {
    return request({
      url: url + 'delete',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/inquiry.js